import { Component, OnInit, Input } from '@angular/core';
import { CaseService } from 'src/app/services/case.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { DictionaryService } from 'src/app/services/dictionary.service';
import { EfileService} from 'src/app/services/efile.service';

@Component({
    selector: 'app-case-efile',
    templateUrl: './case-efile.component.html'
})
export class CaseEFileComponent implements OnInit {

    @Input() caseId: string;

    myEFileDocs: any[];
    cols: any[];
    typeOfAttachement: any[];

    constructor(private caseService: CaseService, private utilService: UtilitiesService, private dictService: DictionaryService,
                private efileService: EfileService) { }

    ngOnInit() {
        this.cols = [
            { field: 'typeOfAttachmentId', header: 'Document Type' },
            { field: 'description', header: 'Description' },
        ];
        let dicts = this.dictService.getDictionaries();
        this.typeOfAttachement = dicts.documentTypes;
        this.myEFileDocs = [];  // initialize array so it is defined and does not generate an error in the template
        if (!this.caseId) {
            return; // this is a NEW case and has no E-Filed docs to view...
        }
        // from .../efile/dict/typeOfAttachment API
        /* this.typeOfAttachement = [
            { "id": 0, "name": "Application"},
            { "id": 1, "name": "Agent Authorization" },
            { "id": 5, "name": "Other" },
            { "id": 4, "name": "Other Explanation" },
            { "id": 3, "name": "Personal Property Description" },
            { "id": 2, "name": "Tax Notice" }
        ]; */
        this.utilService.doAudit(this.caseId,'EFile Docs; getting case:')
        //console.log('EFile Docs; getting case: ' + this.caseId);
        //[{ "id": 26, "typeOfAttachmentId": 1, "fileName": "Vulcan-Language-guide.pdf", "description": "", "url": "https://parodanstorage.blob.core.windows.net/attachments/0be6d547-6c71-4165-82e9-8d3adc7ce219.pdf", "filenameInStorage": "0be6d547-6c71-4165-82e9-8d3adc7ce219.pdf" }]
        // create link to E-File application form (pdf)
        this.caseService.getCase(this.caseId).subscribe(data => {
            if (data) {
                if (data.efileId) {
                    this.utilService.doAudit(data.efileId,'getting efile docs:');
                    // console.log('getting efile docs: ' + data.efileId);
                    let myAppUrl = this.utilService.getCreatePdfUrl() + this.utilService.genEncryptId(data.efileId.toString());
                    this.myEFileDocs.push({
                        typeOfAttachmentId: 0,
                        typeOfDocument: this.typeOfAttachement.filter(t => t.id == 0),
                        fileName: '',
                        url: myAppUrl,
                    });
                    this.efileService.getEFileDocs(data.efileId.toString()).subscribe(data2 => {
                        //console.log(data2);
                      this.utilService.doAudit(data2, 'response from getEfileDocs:');
                        for (let doc of data2) {
                            doc.typeOfDocument = this.typeOfAttachement.filter(t => t.id == doc.typeOfAttachmentId)
                            this.myEFileDocs.push(doc);
                        };
                        //this.myEFileDocs = data2;
                        //console.log(this.myEFileDocs);
                    })
                }
            }
        });
    }
    // view document uploaded to EFile system
    viewEfileDoc(myUrl: string) {
        this.utilService.doAudit(myUrl,'myUrl:');
        window.open(myUrl, '_blank');
    }
    viewEfileDocNEW(myUrl: string) {
      this.utilService.doAudit(myUrl,'Getting blob from myUrl:');
      this.utilService.getBlob(myUrl, false).subscribe(data => {
        if (data) {
          this.utilService.openNewWindow(data);
        }
      });
    }
}
